export const iconMap = [
    {
        name: "credit",
        icon: require("!!url?limit=1024!image!resources/images/icn-credit.svg"),
        color: "#7e53c5",
    },
    {
        name: "life",
        icon: require("!!url?limit=1024!image!resources/images/icn-life.svg"),
        color: "#ffcb00",
    },
    {
        name: "health",
        icon: require("!!url?limit=1024!image!resources/images/icn-health.svg"),
        color: "#ef3c79",
    },
    {
        name: "building",
        icon: require("!!url?limit=1024!image!resources/images/icn-home.svg"),
        color: "#63bc66",
    },
    {
        name: "family",
        icon: require("!!url?limit=1024!image!resources/images/icn-family.svg"),
        color: "#ffa800",
    },
    {
        name: "vehicle",
        icon: require("!!url?limit=1024!image!resources/images/icn-automotive.svg"),
        color: "#5b69c3",
    },
    {
        name: "work_accident",
        icon: require("!!url?limit=1024!image!resources/images/icn-workinjuries.svg"),
        color: "#8e6e62",
    },
    {
        name: "high_risk",
        icon: require("!!url?limit=1024!image!resources/images/icn-fire.svg"),
        color: "#f1524b",
    },
    {
        name: "transport",
        icon: require("!!url?limit=1024!image!resources/images/icn-transport.svg"),
        color: "#3ba3f8",
    },
    {
        name: "several",
        icon: require("!!url?limit=1024!image!resources/images/icn-misc.svg"),
        color: "#979797",
    },
]



// WEBPACK FOOTER //
// ./components/easinsure/contracts/icon-map.js